export interface ResponseError {
  data: object;
  code: number;
  display: boolean;
  message: string;
  stackTrace: string;
}
